export {default as voronoi} from "./voronoi";



//////////////////
// WEBPACK FOOTER
// ./~/d3-voronoi/src/index.js
// module id = 947
// module chunks = 0